<template>
  <v-card flat tile>
    <div class="heading text-center">Our Values</div>
    <v-row v-for="(value, i) in values" :key="value.heading" class="my-5">
      <v-col class="d-flex justify-center align-center" cols="12" sm="5"
        ><div class="sub-heading" style="max-width: 60%">
          {{ value.heading }}
        </div></v-col
      >
      <v-col v-if="$vuetify.breakpoint.smAndUp" class="text-center" cols="2">
        <v-divider class="primary" vertical></v-divider
      ></v-col>
      <v-col cols="12" sm="5">
        <div class="d-flex justify-center align-center">
          <div class="body" style="max-width:60%;">{{ value.text }}</div>
        </div>
        <v-divider
          v-if="i < values.length - 1 && isMobile"
          class="mx-5 my-5"
        ></v-divider>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      values: [
        {
          heading: 'We believe in freedom',
          text: `We believe in the freedom to do what we are passionate about.`,
        },
        {
          heading: 'We build with gratitude',
          text: `Being grateful daily, we build our future one day at a time.`,
        },
        {
          heading: 'Community is important',
          text: `Many special people helped to shape us and what we have achieved.`,
        },
        {
          heading: 'Adding value feeds our soul',
          text: `If we can’t add value to those we work with, we have not lived. Adding value is food for our souls.`,
        },
        {
          heading: 'Wise decisions, inspired action.',
          text: `We are dedicated to make every life decision with wisdom. That wisdom leads us to inspired action.`,
        },
        {
          heading: 'Not a problem, but a challenge',
          text: `We face challenges head-on and achieve incredible results. Challenges inspire us to press on.`,
        },
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>

<style></style>
